/**
 * Converts a string to kebab-case
 * @param str - The string to convert
 * @returns The kebab-case string
 */
const kebabCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1-$2") // Add hyphen between lowercase and uppercase
    .replace(/[\s_]+/g, "-") // Replace spaces and underscores with hyphens
    .toLowerCase(); // Convert to lowercase
};

export default kebabCase;
